import Image from 'next/image';
import Link from 'next/link';

export function BookmakerLogoImage({
  url,
  imageUrl,
  alt,
}: {
  url: string;
  alt: string;
  imageUrl: string;
}) {
  return (
    <div className="h-[200px] w-full shrink-0 overflow-hidden lg:h-[110px]">
      <Link href={url}>
        <Image
          alt={alt}
          className="h-full w-full rounded-lg object-cover"
          height={0}
          sizes="(max-width: 640px) 100vw, (max-width: 1024px) 160px, 176px"
          src={imageUrl}
          width={0}
        />
      </Link>
    </div>
  );
}
